import { useState } from "react";
import axios from "axios";
import { getHeaders } from "../utils/shared/headers";
import { EVENT_STATUS } from "../constants/event";
import { fetchAndCacheState } from "../../Upshow";
import { BASE_URL } from "../constants/general";

const useToggleSubscription = (fetchEvents) => {
    const [isSubscribeLoading, setIsSubscribeLoading] = useState(false);

    const handleToggleSubscription = async (event) => {
        setIsSubscribeLoading(true);
        try {
            if (event.isDeviceSubscribed && event.status !== EVENT_STATUS.LIVE) {
                await axios.post(`${BASE_URL}/v6/unsubscribe/${event.id}`, {}, { headers: getHeaders() });
            } else {
                await axios.post(`${BASE_URL}/v6/subscribe/${event.id}`, {}, { headers: getHeaders() });
            }
            await fetchEvents();
            if (event.status === EVENT_STATUS.LIVE) {
                await fetchAndCacheState();
            }
            setIsSubscribeLoading(false);
        } catch (err) {
            console.error("toggleSubscription error:", err);
            setIsSubscribeLoading(false);
        };
    };

    return { handleToggleSubscription, isSubscribeLoading };
};

export default useToggleSubscription;
